<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import Loading from 'vue-loading-overlay';
import ModalNewAlbumBellaCloud from "components/Modais/ModalNewAlbumBellaCloud.vue"
</script>
<template>
  <MainLayout #="{showModalMessages}">
    <div class="slot-body">
      <div class="block--gray">
        <div class="container">
          <div class="row pt-3">
            <div class="col-lg-4 pt-4">
              <h1 class="title">{{ translate.title }}</h1>
            </div>
            <div class="col-lg-5 pt-2 d-flex align-items-center">
              <span class="subtitle">{{ translate.subTitle }}</span>
            </div>
            <div v-if="isLoggedIn" class="col-lg-2 d-flex align-items-center justify-content-center cursor-pointer" @click="newAlbum(true)">
              <div class="icon-new-album"></div>
              {{ 'Novo Album' }}
            </div>
          </div>
          <hr>
        </div>
        <!-- Meus Albums Deslogados-->
        <div class="pb-5" v-if="!isLoggedIn">
          <div class="container d-flex flex-column align-items-start justify-content-center">
            <span class="wellcome mb-4">{{ translate.titleWellcome }}</span>
            <span class="description" v-html="translate.descriptionWellcome"></span>
            <span class="link-login" @click="goLink('LoginPage', { locale })">{{ translate.linkLogin }}</span>
          </div>
        </div>
        <!-- Meus Albums Logados-->
        <div class="pb-5" v-else>
          <div class="container">
            <loading v-model:active="loadingMyAlbum" :is-full-page="false" color="#b20000" height="200" />
            <div class="row pt-3" v-if="list.data && list.data.length">
              <div v-for="item in list.data" class="col-lg-3 mt-5" :key="item.id">
                <div class="dropright col-2 d-flex justify-content-start">
                            <font-awesome-icon class="dropdown-toggle" :icon="['fas', 'bars']" data-toggle="dropdown" aria-expanded="false" @click="showDropMenu = !showDropMenu"/>
                        <div class="dropdown-menu" :class="{ show: showDropMenu }" >
                                <a class="dropdown-item" href="#">
                                    <span style="margin-right: 15px;" class="cursor-pointer"
                                    @click="edit(item)">
                                    {{ translate.editPasta }}
                                    </span>
                                </a>
                                <a class="dropdown-item" href="#">
                                    <span style="margin-right: 15px;" class="cursor-pointer" @click="deleteAlbum(item.id , showModalMessages)">
                                      {{ translate.deletePasta }}
                                </span>
                                </a>
                            </div>
                        </div>
                <div class="d-flex flex-row align-items-center justify-content-center flex-wrap block-gray"
                  @click="goLink('BellaCloudAlbumPage', { albumId: item.id, nameAlbum: item.url, locale }, {q: translate.title})">
                  <div class="photos d-flex flex-row align-items-center justify-content-center flex-wrap pt-3">
                    <img class="thumb-pastas col-6" v-for="(photo, index) in item.photo_thumb" :src="photo"
                      :alt="item.name + '-' + index" :key="index">
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="name-pastas">{{ item.name }}</span>
                  </div>

                </div>
              </div>
              <vue-awesome-paginate class="mt-2" v-if="list.data" :modelValue="list.current_page"
            :total-items="list.total" :items-per-page="list.per_page" :max-pages-shown="3"
            :on-click="onClickHandlerMyAlbuns" />
            </div>
            <div class="row pt-3" v-else>
              <span>{{ translate.notMyAlbuns }}</span>
            </div>
          </div>
        </div>
        <!-- Top Albums -->
        <div class="container">
          <hr>
          <div class="row pt-3 align-items-center">
            <div class="col-lg-4 pt-4">
              <span class="title">{{ translate.topAlbuns }}</span>
            </div>
            <div class="col-lg-3 offset-lg-5 pt-4">
              <router-link :to="{ name: 'BellaCloudTopPage', params: { locale } }" class="button d-none d-md-inline-flex">
                {{ translate.seeAllTops }} <i class="icon-arrow-right"></i></router-link>
            </div>
          </div>
        </div>
        <div class="pb-5">
          <div class="container">
            <loading v-model:active="loadingTopAlbum" :is-full-page="false" color="#b20000" height="200" />
            <div class="row pt-3">
              <div v-for="item in listTop" class="col-lg-3 col-md-6 col-sm-6 mt-5" :key="item.id">
                <div class="d-flex flex-row align-items-center justify-content-center block-gray flex-wrap"
                  @click="goLink('BellaCloudAlbumPage', { albumId: item.id, nameAlbum: item.url, locale }, {q: translate.topAlbuns})">
                  <div class="photos d-flex flex-row align-items-center justify-content-center flex-wrap pt-3">
                    <img class="thumb-pastas col-6" v-for="(photo, index) in item.photo_thumb" :src="photo"
                      :alt="item.name + '-' + index" :key="index">
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="name-pastas">{{ item.name }}</span>
                  </div>
                  <font-awesome-icon :icon="['fas', 'user']" style="font-size: 10px; margin-inline-end: 5px;" />
                  {{ translate.by }}
                  {{ item.user.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Others Albums -->
        <div class="container">
          <hr>
          <div class="row pt-3">
            <div class="col-lg-10 pt-4">
              <span class="title">{{ translate.othersAlbums }}</span>
            </div>
          </div>
        </div>
        <div class="pb-5">
          <div class="container mb-5">
            <loading v-model:active="loadingOtherAlbum" :is-full-page="false" color="#b20000" height="200" />
            <div class="row pt-3">
              <div v-for="item in paginationOther.data" class="col-lg-3 mt-5" :key="item.id">
                <div class="d-flex flex-row align-items-center justify-content-center block-gray flex-wrap "
                  @click="goLink('BellaCloudAlbumPage', { albumId: item.id, nameAlbum: item.url, locale })">
                  <div class="photos d-flex flex-row align-items-center justify-content-center flex-wrap pt-3">
                    <img class="thumb-pastas col-6" v-for="(photo, index) in item.photo_thumb" :src="photo"
                      :alt="item.name + '-' + index" :key="index">
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="name-pastas">{{ item.name }}</span>
                  </div>
                  <font-awesome-icon :icon="['fas', 'user']" style="font-size: 10px; margin-inline-end: 5px;" />
                  {{ translate.by }}
                  {{ item.user.name }}
                </div>
              </div>
            </div>
          </div>
          <vue-awesome-paginate v-if="paginationOther.data" :modelValue="paginationOther.current_page"
            :total-items="paginationOther.total" :items-per-page="paginationOther.per_page" :max-pages-shown="3"
            :on-click="onClickHandler" />
        </div>

      </div>
    </div>
    <ModalNewAlbumBellaCloud :show="modalNewAlbum" @showModalClose="newAlbum" @showModalMessages="showModalMessages" :edit="editar" :item="itemEdit"/>
  </MainLayout>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'
import { localeStore } from 'stores/locale'
import tradutor from 'tradutors/bellacloud'
import api from '../../api'
import { userStore } from '../../stores/user';
import router from '../../router';

export default defineComponent({
  name: 'ContactUsView',
  computed: {
    ...mapState(localeStore, ['locale']),
    ...mapState(userStore, ['isLoggedIn']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return tradutor.portugues
      } else {
        return tradutor.ingles
      }
    }
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.translate.title,
        page_url: window.location.origin + this.$route.fullPath,
        page_description: this.locale == 'pt-br' ?
          `O Bella Cloud é um lugar onde você armazena as fotos e vídeos do Bella da Semana que mais gosta. Nele é possível criar álbuns privados, ou compartilhados com seus amigos e outros usuários.` :
          `Bella Cloud is a place where you store the photos and videos of the Bella Club you like best. It is possible to create private albums, or shared with your friends and other users.`,
        page_image: '/favicon.ico',
        page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/bellacloud",
        page_url_en: "https://belladasemana.com.br/en/bellacloud",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      }
    }
  },
  data() {
    return {
      list: {
        current_page: 1,
        total: 1,
        per_page: 1,
        data: null
      },
      listTop: [],
      showDropMenu:false,
      paginationOther: {
        current_page: 1,
        total: 1,
        per_page: 1,
        data: null
      },
      loadingMyAlbum: true,
      loadingTopAlbum: true,
      loadingOtherAlbum: true,
      modalNewAlbum: false,
      editar: false,
      itemEdit: null,
    }
  },
  created() {
    const lang = ['pt-br', 'en']
    if (lang.indexOf(this.$route.params.locale) === -1) {
      window.location.replace('/')
    }
    if (this.isLoggedIn)
      this.getMyAlbums()

   this.getTopAlbums()
   this.getOtherAlbums()
  },

  watch: {
    'locale': function () {
      this.getTopAlbums()
      this.getOtherAlbums()
    }
  },
  methods: {
    async getMyAlbums(page='') {
      this.loadingMyAlbum = true
      this.itemEdit = null
      this.editar = false
      this.showDropMenu = false
      api.get(`v1/bellacloud/getMyAlbuns?page=${page}`).then(({ data }) => {
        this.list = data
      })
        .finally(() => this.loadingMyAlbum = false)
    },

    async getTopAlbums() {
      this.loadingTopAlbum = true
      api.get(`v1/bellacloud/topAlbums?locale=${this.locale}`).then(({ data }) => {
        this.listTop = data
      }).finally(() => this.loadingTopAlbum = false)
    },

    async getOtherAlbums(page = '') {
      this.loadingOtherAlbum = true
      api.get(`v1/bellacloud/otherAlbums?locale=${this.locale ?? this.$route.params.locale}&page=${page}`).then(({ data }) => {
        this.paginationOther = data
      })
        .finally(() => this.loadingOtherAlbum = false)
    },
    async onClickHandler(page: number) {
      await this.getOtherAlbums(page)
    },
    async onClickHandlerMyAlbuns(page: number) {
      await this.getMyAlbums(page)
    },
    async deleteAlbum(id, message){
      api.delete(`v1/bellacloud/removeAlbum/${id}`).then(() => {
        message({message:{
          show: true, title: 'Aviso', textButton: 'Fechar',
          textBoby: this.locale == 'pt-br' ? 'Álbum removida com sucesso!' : 'Albun removed successfully!'
          }})
        this.getMyAlbums()
      }).catch(()=>{
        message({message:{
          show: true, title: 'Error', textButton: 'Fechar', textBoby: this.locale == 'pt-br' ?
                                "Falha ao remover álbum!" :
                                'Failed to remove albuns'
          }})
      }).finally(()=> this.showDropMenu = false)
    },
    async edit(item){
      this.itemEdit = item
      this.editar = true
      this.modalNewAlbum = true
      
    },
    goLink(name, params = null, query = null) {
      router.push({ name, params, query })
    },
    newAlbum(val) {
      this.editar = false
      this.modalNewAlbum = val

      if(!val)
      this.getMyAlbums()
    }
  }
})
</script>

<style lang="css" scoped>
.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
}

.container {
  min-height: 65px;
}

.wellcome {
  font-size: 24px;
  font-weight: bold;
  line-height: 15px;
  color: #000000;
  font-family: "Roboto";
}


.title {
  font-family: 'Bebas-Neue-Light';
  height: 77px;
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.title {
  font-family: 'Bebas-Neue-Light';
  height: 77px;
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.name-pastas {
  color: #b20000;
  font-family: 'Roboto-Medium';
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}

.subtitle {
  color: #5b5858;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.block-gray {
  border-radius: 8px;
  padding: 15px;
  min-height: 296px;
  background-image: url('../../assets/img/icone-bella-cloud-2.svg');
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

.photos {
  width: 100%;
  min-height: 200px;
}

.thumb-pastas {
  box-sizing: border-box;
  height: 87px;
  width: 87px;
  border: 1px solid #979797;
  background-color: #D8D8D8;
  border-radius: 5px;
  margin: 5px;
  object-fit: cover;
  object-position: center top;
}

hr {
  height: 2px;
  opacity: 0.1;
  transform: scaleY(-1);
  background-color: #000000;
}

.link-login {
  font-size: 18px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
.icon-new-album{
    background-image: url('../../assets/img/icone-circulo-pontilhado-cruz-meio.svg');
    width: 54px;
    height: 54px;
    margin-inline-end: 15px;
  }

  .dropdown-toggle {
    &:after {
      font-family: 'Roboto-Regular';
      font-size: 18px;
      content: '\e809';
      margin: 0;
      border: none;
      vertical-align: top;
    }
  }

  .dropdown-menu{
    margin: 1rem;
    background-color: #fff;
    color: #999;
    right: auto;
    bottom: auto;
    top: 0;
    left: 1rem;
  }

  .dropdown-item{
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 16px;
    padding: 0.75rem;
  }
  .dropright{
    position: absolute;
    top: 0;
    padding: 0.25rem;
    margin: 0.25rem;
    z-index: 20;
  }


/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .subtitle {
    color: #b20000;
  }

  .thumb-pastas {
    height: 120px;
    width: 120px;
  }

  .wellcome {
    font-size: 20px;
    line-height: 22px;
  }

}

@media only screen and (max-width: 1024px) and (min-width: 770px) {
  .thumb-pastas {
    height: 80px;
    width: 80px;
  }

}
</style>
